"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/portal_service.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalMessageServiceGetUserDmNotificationSettingResponse = exports.PortalMessageServiceGetUserDmNotificationSettingRequest = exports.PortalMessageServiceUpdateUserDmNotificationSettingResponse = exports.PortalMessageServiceUpdateUserDmNotificationSettingRequest = exports.PortalMessageServiceGetUnreadMessageExistsStatusResponse = exports.PortalMessageServiceGetUnreadMessageExistsStatusRequest = exports.PortalMessageServiceGetSignedUrlForFileUploadResponse = exports.PortalMessageServiceGetSignedUrlForFileUploadRequest = exports.PortalMessageServiceDeleteDMMessageResponse = exports.PortalMessageServiceDeleteDMMessageRequest = exports.PortalMessageServiceGetNewDMThreadResponse = exports.PortalMessageServiceGetNewDMThreadRequest = exports.PortalMessageServiceGetDMUnselectedThreadListResponse = exports.PortalMessageServiceGetDMUnselectedThreadListRequest = exports.PortalMessageServiceGetDMThreadResponse = exports.PortalMessageServiceGetDMThreadRequest = exports.PortalMessageServicePostDMMessageResponse = exports.PortalMessageServicePostDMMessageRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const portal_common_pb_1 = require("./portal_common_pb");
/**
 * @generated from message spwn.message.v1.PortalMessageServicePostDMMessageRequest
 */
class PortalMessageServicePostDMMessageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * messageに含まれるlink tagのurlを保持したlist
         *
         * @generated from field: repeated string link_url_list = 2;
         */
        this.linkUrlList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServicePostDMMessageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServicePostDMMessageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServicePostDMMessageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServicePostDMMessageRequest, a, b);
    }
}
exports.PortalMessageServicePostDMMessageRequest = PortalMessageServicePostDMMessageRequest;
PortalMessageServicePostDMMessageRequest.runtime = protobuf_1.proto3;
PortalMessageServicePostDMMessageRequest.typeName = "spwn.message.v1.PortalMessageServicePostDMMessageRequest";
PortalMessageServicePostDMMessageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_message", kind: "message", T: portal_common_pb_1.PortalMessageDmMessage },
    { no: 2, name: "link_url_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServicePostDMMessageResponse
 */
class PortalMessageServicePostDMMessageResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string dm_message_id = 1;
         */
        this.dmMessageId = "";
        /**
         * requestのlink_url_listに含まれるlinkからiframelyで生成したhtmlのlist
         *
         * @generated from field: repeated string ogp_card_html_list = 2;
         */
        this.ogpCardHtmlList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServicePostDMMessageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServicePostDMMessageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServicePostDMMessageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServicePostDMMessageResponse, a, b);
    }
}
exports.PortalMessageServicePostDMMessageResponse = PortalMessageServicePostDMMessageResponse;
PortalMessageServicePostDMMessageResponse.runtime = protobuf_1.proto3;
PortalMessageServicePostDMMessageResponse.typeName = "spwn.message.v1.PortalMessageServicePostDMMessageResponse";
PortalMessageServicePostDMMessageResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ogp_card_html_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetDMThreadRequest
 */
class PortalMessageServiceGetDMThreadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string chat_partner_id = 1;
         */
        this.chatPartnerId = "";
        /**
         * メッセージのぺジネーションのページナンバー
         *
         * @generated from field: int32 page_number = 2;
         */
        this.pageNumber = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetDMThreadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetDMThreadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetDMThreadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetDMThreadRequest, a, b);
    }
}
exports.PortalMessageServiceGetDMThreadRequest = PortalMessageServiceGetDMThreadRequest;
PortalMessageServiceGetDMThreadRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetDMThreadRequest.typeName = "spwn.message.v1.PortalMessageServiceGetDMThreadRequest";
PortalMessageServiceGetDMThreadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "chat_partner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetDMThreadResponse
 */
class PortalMessageServiceGetDMThreadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetDMThreadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetDMThreadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetDMThreadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetDMThreadResponse, a, b);
    }
}
exports.PortalMessageServiceGetDMThreadResponse = PortalMessageServiceGetDMThreadResponse;
PortalMessageServiceGetDMThreadResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetDMThreadResponse.typeName = "spwn.message.v1.PortalMessageServiceGetDMThreadResponse";
PortalMessageServiceGetDMThreadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "thread", kind: "message", T: portal_common_pb_1.PortalMessageThread },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetDMUnselectedThreadListRequest
 */
class PortalMessageServiceGetDMUnselectedThreadListRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.message.v1.PortalMessageSender sender = 1;
         */
        this.sender = portal_common_pb_1.PortalMessageSender.UNSPECIFIED;
        /**
         * @generated from field: string user_or_brand_id = 2;
         */
        this.userOrBrandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetDMUnselectedThreadListRequest, a, b);
    }
}
exports.PortalMessageServiceGetDMUnselectedThreadListRequest = PortalMessageServiceGetDMUnselectedThreadListRequest;
PortalMessageServiceGetDMUnselectedThreadListRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetDMUnselectedThreadListRequest.typeName = "spwn.message.v1.PortalMessageServiceGetDMUnselectedThreadListRequest";
PortalMessageServiceGetDMUnselectedThreadListRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "sender", kind: "enum", T: protobuf_1.proto3.getEnumType(portal_common_pb_1.PortalMessageSender) },
    { no: 2, name: "user_or_brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetDMUnselectedThreadListResponse
 */
class PortalMessageServiceGetDMUnselectedThreadListResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.message.v1.PortalMessageUnselectedThread threads = 1;
         */
        this.threads = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetDMUnselectedThreadListResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetDMUnselectedThreadListResponse, a, b);
    }
}
exports.PortalMessageServiceGetDMUnselectedThreadListResponse = PortalMessageServiceGetDMUnselectedThreadListResponse;
PortalMessageServiceGetDMUnselectedThreadListResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetDMUnselectedThreadListResponse.typeName = "spwn.message.v1.PortalMessageServiceGetDMUnselectedThreadListResponse";
PortalMessageServiceGetDMUnselectedThreadListResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "threads", kind: "message", T: portal_common_pb_1.PortalMessageUnselectedThread, repeated: true },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetNewDMThreadRequest
 */
class PortalMessageServiceGetNewDMThreadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string chat_partner_id = 1;
         */
        this.chatPartnerId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetNewDMThreadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetNewDMThreadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetNewDMThreadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetNewDMThreadRequest, a, b);
    }
}
exports.PortalMessageServiceGetNewDMThreadRequest = PortalMessageServiceGetNewDMThreadRequest;
PortalMessageServiceGetNewDMThreadRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetNewDMThreadRequest.typeName = "spwn.message.v1.PortalMessageServiceGetNewDMThreadRequest";
PortalMessageServiceGetNewDMThreadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "chat_partner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetNewDMThreadResponse
 */
class PortalMessageServiceGetNewDMThreadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetNewDMThreadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetNewDMThreadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetNewDMThreadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetNewDMThreadResponse, a, b);
    }
}
exports.PortalMessageServiceGetNewDMThreadResponse = PortalMessageServiceGetNewDMThreadResponse;
PortalMessageServiceGetNewDMThreadResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetNewDMThreadResponse.typeName = "spwn.message.v1.PortalMessageServiceGetNewDMThreadResponse";
PortalMessageServiceGetNewDMThreadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "thread", kind: "message", T: portal_common_pb_1.PortalMessageThread },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceDeleteDMMessageRequest
 */
class PortalMessageServiceDeleteDMMessageRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string dm_message_id = 1;
         */
        this.dmMessageId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceDeleteDMMessageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceDeleteDMMessageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceDeleteDMMessageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceDeleteDMMessageRequest, a, b);
    }
}
exports.PortalMessageServiceDeleteDMMessageRequest = PortalMessageServiceDeleteDMMessageRequest;
PortalMessageServiceDeleteDMMessageRequest.runtime = protobuf_1.proto3;
PortalMessageServiceDeleteDMMessageRequest.typeName = "spwn.message.v1.PortalMessageServiceDeleteDMMessageRequest";
PortalMessageServiceDeleteDMMessageRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceDeleteDMMessageResponse
 */
class PortalMessageServiceDeleteDMMessageResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceDeleteDMMessageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceDeleteDMMessageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceDeleteDMMessageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceDeleteDMMessageResponse, a, b);
    }
}
exports.PortalMessageServiceDeleteDMMessageResponse = PortalMessageServiceDeleteDMMessageResponse;
PortalMessageServiceDeleteDMMessageResponse.runtime = protobuf_1.proto3;
PortalMessageServiceDeleteDMMessageResponse.typeName = "spwn.message.v1.PortalMessageServiceDeleteDMMessageResponse";
PortalMessageServiceDeleteDMMessageResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetSignedUrlForFileUploadRequest
 */
class PortalMessageServiceGetSignedUrlForFileUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名
         *
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetSignedUrlForFileUploadRequest, a, b);
    }
}
exports.PortalMessageServiceGetSignedUrlForFileUploadRequest = PortalMessageServiceGetSignedUrlForFileUploadRequest;
PortalMessageServiceGetSignedUrlForFileUploadRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetSignedUrlForFileUploadRequest.typeName = "spwn.message.v1.PortalMessageServiceGetSignedUrlForFileUploadRequest";
PortalMessageServiceGetSignedUrlForFileUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetSignedUrlForFileUploadResponse
 */
class PortalMessageServiceGetSignedUrlForFileUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロード時に指定するヘッダー
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用のURL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        /**
         * ダウンロード用のURL
         *
         * @generated from field: string url_for_download = 4;
         */
        this.urlForDownload = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 5;
         */
        this.s3ObjectPath = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetSignedUrlForFileUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetSignedUrlForFileUploadResponse, a, b);
    }
}
exports.PortalMessageServiceGetSignedUrlForFileUploadResponse = PortalMessageServiceGetSignedUrlForFileUploadResponse;
PortalMessageServiceGetSignedUrlForFileUploadResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetSignedUrlForFileUploadResponse.typeName = "spwn.message.v1.PortalMessageServiceGetSignedUrlForFileUploadResponse";
PortalMessageServiceGetSignedUrlForFileUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetUnreadMessageExistsStatusRequest
 */
class PortalMessageServiceGetUnreadMessageExistsStatusRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetUnreadMessageExistsStatusRequest, a, b);
    }
}
exports.PortalMessageServiceGetUnreadMessageExistsStatusRequest = PortalMessageServiceGetUnreadMessageExistsStatusRequest;
PortalMessageServiceGetUnreadMessageExistsStatusRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetUnreadMessageExistsStatusRequest.typeName = "spwn.message.v1.PortalMessageServiceGetUnreadMessageExistsStatusRequest";
PortalMessageServiceGetUnreadMessageExistsStatusRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetUnreadMessageExistsStatusResponse
 */
class PortalMessageServiceGetUnreadMessageExistsStatusResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 未読メッセージが存在するDM相手の数
         *
         * @generated from field: int32 number_of_unread_chat_partners = 1;
         */
        this.numberOfUnreadChatPartners = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetUnreadMessageExistsStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetUnreadMessageExistsStatusResponse, a, b);
    }
}
exports.PortalMessageServiceGetUnreadMessageExistsStatusResponse = PortalMessageServiceGetUnreadMessageExistsStatusResponse;
PortalMessageServiceGetUnreadMessageExistsStatusResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetUnreadMessageExistsStatusResponse.typeName = "spwn.message.v1.PortalMessageServiceGetUnreadMessageExistsStatusResponse";
PortalMessageServiceGetUnreadMessageExistsStatusResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "number_of_unread_chat_partners", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceUpdateUserDmNotificationSettingRequest
 */
class PortalMessageServiceUpdateUserDmNotificationSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool receive_email = 1;
         */
        this.receiveEmail = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceUpdateUserDmNotificationSettingRequest, a, b);
    }
}
exports.PortalMessageServiceUpdateUserDmNotificationSettingRequest = PortalMessageServiceUpdateUserDmNotificationSettingRequest;
PortalMessageServiceUpdateUserDmNotificationSettingRequest.runtime = protobuf_1.proto3;
PortalMessageServiceUpdateUserDmNotificationSettingRequest.typeName = "spwn.message.v1.PortalMessageServiceUpdateUserDmNotificationSettingRequest";
PortalMessageServiceUpdateUserDmNotificationSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "receive_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceUpdateUserDmNotificationSettingResponse
 */
class PortalMessageServiceUpdateUserDmNotificationSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceUpdateUserDmNotificationSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceUpdateUserDmNotificationSettingResponse, a, b);
    }
}
exports.PortalMessageServiceUpdateUserDmNotificationSettingResponse = PortalMessageServiceUpdateUserDmNotificationSettingResponse;
PortalMessageServiceUpdateUserDmNotificationSettingResponse.runtime = protobuf_1.proto3;
PortalMessageServiceUpdateUserDmNotificationSettingResponse.typeName = "spwn.message.v1.PortalMessageServiceUpdateUserDmNotificationSettingResponse";
PortalMessageServiceUpdateUserDmNotificationSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetUserDmNotificationSettingRequest
 */
class PortalMessageServiceGetUserDmNotificationSettingRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetUserDmNotificationSettingRequest, a, b);
    }
}
exports.PortalMessageServiceGetUserDmNotificationSettingRequest = PortalMessageServiceGetUserDmNotificationSettingRequest;
PortalMessageServiceGetUserDmNotificationSettingRequest.runtime = protobuf_1.proto3;
PortalMessageServiceGetUserDmNotificationSettingRequest.typeName = "spwn.message.v1.PortalMessageServiceGetUserDmNotificationSettingRequest";
PortalMessageServiceGetUserDmNotificationSettingRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.PortalMessageServiceGetUserDmNotificationSettingResponse
 */
class PortalMessageServiceGetUserDmNotificationSettingResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool receive_email = 1;
         */
        this.receiveEmail = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageServiceGetUserDmNotificationSettingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageServiceGetUserDmNotificationSettingResponse, a, b);
    }
}
exports.PortalMessageServiceGetUserDmNotificationSettingResponse = PortalMessageServiceGetUserDmNotificationSettingResponse;
PortalMessageServiceGetUserDmNotificationSettingResponse.runtime = protobuf_1.proto3;
PortalMessageServiceGetUserDmNotificationSettingResponse.typeName = "spwn.message.v1.PortalMessageServiceGetUserDmNotificationSettingResponse";
PortalMessageServiceGetUserDmNotificationSettingResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "receive_email", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
//# sourceMappingURL=portal_service_pb.js.map